export default {"src":"/_next/static/media/lightweight.3a653749.svg","height":23,"width":26,"blurWidth":0,"blurHeight":0};